module.exports = __webpack_public_path__ + "img/5.b1279b26.png";